// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8229 ? "9da6db1e" : chunkId) + "." + {"294":"b2d121590d71b8cc","8229":"a7dddab4b878ba61"}[chunkId] + ".js";
};